import {
  GET_ADMINS_SWITCHABLE_ACCS,
  GET_ADMINS_SWITCHABLE_ACCS_FAIL,
  GET_ADMINS_SWITCHABLE_ACCS_SUCCESS,
  GET_ADMINS_LIST,
  GET_ADMINS_LIST_FAIL,
  GET_ADMINS_LIST_SUCCESS,
  SWITCH_ADMIN_ACCOUNT,
  SWITCH_ADMIN_ACCOUNT_SUCCESS,
  SWITCH_ADMIN_ACCOUNT_FAIL,
  REMOVE_SWITCH_ADMIN_ACCOUNT,
  REMOVE_SWITCH_ADMIN_ACCOUNT_SUCCESS,
  REMOVE_SWITCH_ADMIN_ACCOUNT_FAIL,
} from "./actionTypes";

export const getAdminsList = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: GET_ADMINS_LIST,
  payload: { data, onSuccess, onError },
});

export const getAdminsListSuccess = data => ({
  type: GET_ADMINS_LIST_SUCCESS,
  payload: data,
});

export const getAdminsListFail = data => ({
  type: GET_ADMINS_LIST_FAIL,
  payload: data,
});

export const removeAdminSwitchAcc = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: REMOVE_SWITCH_ADMIN_ACCOUNT,
  payload: { data, onSuccess, onError },
});

export const removeAdminSwitchAccSuccess = data => ({
  type: REMOVE_SWITCH_ADMIN_ACCOUNT_SUCCESS,
  payload: data,
});

export const removeAdminSwitchAccFail = data => ({
  type: REMOVE_SWITCH_ADMIN_ACCOUNT_FAIL,
  payload: data,
});

export const adminSwitchableAcc = (data = {}, onSuccess = () => {}, onError = () => {}, header = {}) => ({
  type: GET_ADMINS_SWITCHABLE_ACCS,
  payload: { data, onSuccess, onError, header },
});

export const adminSwitchableAccSuccess = data => ({
  type: GET_ADMINS_SWITCHABLE_ACCS_SUCCESS,
  payload: data,
});

export const adminSwitchableAccFail = data => ({
  type: GET_ADMINS_SWITCHABLE_ACCS_FAIL,
  payload: data,
});

export const switchAdminAcc = (data = {}, onSuccess = () => {}, onError = () => {}, header = {}) => ({
  type: SWITCH_ADMIN_ACCOUNT,
  payload: { data, onSuccess, onError, header },
});

export const switchAdminAccSuccess = data => ({
  type: SWITCH_ADMIN_ACCOUNT_SUCCESS,
  payload: data,
});

export const switchAdminAccFail = data => ({
  type: SWITCH_ADMIN_ACCOUNT_FAIL,
  payload: data,
});
